<template>
  <div class="step">
    <el-row class="row-box">
      <div class="step-box">
        <!-- <span class="item active" data-activenum="0">Home</span>
        <span class="item" data-activenum="1">About yedeer</span>
        <span class="item" data-activenum="2">Recent Jobs</span> -->
        <span
          :class="[
            'item',
            { active: getPath == '/yedeersindex' || getPath == '/' }
          ]"
        >
          <router-link to="/yedeersindex">{{
            languageDataObj.home[language]
          }}</router-link>
        </span>

        <span :class="['item', { active: getPath == '/aboutyedeer' }]">
          <router-link to="/aboutyedeer">{{
            languageDataObj.aboutYedeer[language]
          }}</router-link>
        </span>
        <!-- <span  :class="['item',{active:getPath == 2}]">Recent Jobs</span> -->
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'Step',
  props: {},
  data () {
    return {
      // isActive:'',
      languageDataObj: null
    }
  },
  created () {
    let urls = this.$route
    this.backLanguageText('officialWebsite')
  },
  mounted () {
    // this.isActive = this
  },
  watch: {
    language: function (val, oldVal) {
      this.backLanguageText('officialWebsite')
    }
  },
  computed: {
    // 获取路由导航
    getPath: {
      get: function () {
        return this.$route.fullPath
      }
    },
    language () {
      return this.$store.state.languageType
    }
  },
  methods: {
    backLanguageText (component) {
      this.languageDataObj = this.$language.changeLanguageType(
        this.language,
        component
      )
      // console.log('打印语言textoverview页面',this.languageDataObj)
    }
  }
}
</script>
<!-- is-finish is-process -->

<style lang="less" scoped>
a {
  text-decoration: none;
  color: rgba(0, 0, 0, 0.75);
}
.step {
  // height: 64px;
  // background: #ffffff;
  // border-radius: 12px;
  min-width: 276px;
  font-family: ArialRoundedmt;

  .row-box {
    position: relative;
  }
  .step-box {
    display: flex;
    .item {
      cursor: pointer;
      margin-right: 40px;
      font-family: arial-unicode-ms;
      color: rgba(0, 0, 0, 0.75);
      font-size: 14px;
      &:last-child {
        margin: 0;
      }
      &.active a {
        color: rgb(0, 0, 0);
        font-weight: 800;
        // font-family: ArialRoundedmt;
      }
    }
  }
}

// /deep/
//   .el-step.is-simple
//   .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
//   font-size: 24px;
// }
// /deep/ .el-step{
//   .el-step__title{
//     min-width: 150px;
//     font-size: 15px;
//     // background-color: #c00;
//   }
//   .el-step__arrow{
//     max-width: 100px;
//   }
// }
</style>
